import React, {useState, useEffect} from "react";
import Tab, { TabGroup } from "@amzn/meridian/tab";
import AttributeView  from './AttributeView';
import ChildContainerView  from './ChildContainerView';
import PackageView  from './PackageView';
import Column from "@amzn/meridian/column";
import Loader from "@amzn/meridian/loader";
import {getContainerDetailData} from "../../../commons/api/GetContainerDetailsResults.js";
import Heading from "@amzn/meridian/heading"
import Row from "@amzn/meridian/row";
import ContainerHistory from "./ContainerHistory";
import { generateBreadCrumb } from "../BreadCrumbsUtils";
import { FormattedMessage } from "react-intl";
import RefreshTimer from "../../../commons/RefreshTimer";

export const ContainerDetailView = (props) => {
    const [currentTab, setCurrentTab] = useState("Attributes");
    const [containerDetailData, setContainerDetailData] = useState(null);
    const [updated, setUpdated] = useState(null);
    const fetchContainerDetail = async (newContainerLabel, newNodeId) => {
        try {
            return await getContainerDetailData(newContainerLabel, newNodeId);
        } catch (e) {
            return null;
        }
    }

    useEffect(() => {
        setContainerDetailData(null);
        fetchContainerDetail(props.entityDetails.entityIds['containerLabel'], props.nodeId).then((containerData) => {
            console.log('new container data :' + containerData.containerLabel);
            setContainerDetailData(containerData);
            setCurrentTab("Attributes");
        });
    }, [props.entityDetails]);

    var startDate = props.startDate ? 'from ' + new Date(props.startDate - (new Date().getTimezoneOffset() * 60 * 1000)).toISOString().substr(0, 10) : '';
    var endDate = props.endDate ? 'to ' + new Date(props.endDate - (new Date().getTimezoneOffset() * 60 * 1000) - (60 * 60 * 24 * 1000)).toISOString().substr(0, 10) : '';

    return (
        <div>
        <Column widths={["grid-5"]} spacingInset="large">
            {generateBreadCrumb(props.previousPath ,"Container Detail")}
            <Row spacingInset="none none medium">
                <Heading level={1}><FormattedMessage id="search.container.detail.headerPrefix" defaultMessage="Container"/> {props.entityDetails.entityIds['containerLabel']} {startDate} {endDate}</Heading>
            </Row>
            <RefreshTimer deps={[containerDetailData, updated]}/>
            <TabGroup value={currentTab} onChange={setCurrentTab}>
                <Tab value="Attributes"><FormattedMessage id="search.container.detail_attributes" defaultMessage="Attributes"/></Tab>
                <Tab value="ChildContainers"><FormattedMessage id="search.container.detail_childContainers" defaultMessage="Child Containers"/></Tab>
                <Tab value="Packages"><FormattedMessage id="search.container.detail_packages" defaultMessage="Packages"/></Tab>
                <Tab value="History"><FormattedMessage id="search.container.detail_history" defaultMessage="History"/></Tab>
            </TabGroup>
            { !containerDetailData ? <Row spacingInset="large" widths={["grid-2"]}><Column/><Loader/></Row> :
              currentTab === "Attributes" ? <AttributeView previousPath = {props.previousPath} data = {containerDetailData}/> : 
              currentTab === "ChildContainers" ?<ChildContainerView setUpdated={setUpdated} previousPath = {props.previousPath} parentContainerLabel = {props.entityDetails.entityIds['containerLabel']} nodeId = {props.nodeId} startDate = {props.startDate} endDate = {props.endDate}/> :
              currentTab === "Packages" ? <PackageView setUpdated={setUpdated} previousPath = {props.previousPath} parentContainerLabel = {props.entityDetails.entityIds['containerLabel']} nodeId = {props.nodeId} startDate = {props.startDate} endDate = {props.endDate}/> :
              <ContainerHistory setUpdated={setUpdated} previousPath = {props.previousPath} containerLabel = {props.entityDetails.entityIds['containerLabel']} nodeId = {props.nodeId} startDate = {props.startDate} endDate = {props.endDate}/>
            }
       </Column>  
       </div>
    )
}





// WEBPACK FOOTER //
// ./src/components/detailPages/containerDetails/ContainerDetailView.js